module.exports = __webpack_public_path__ + "img/800223811.9eeb00bd.png";